import { Box, Typography, styled } from "@mui/material"
import { colors } from "theme"

export const Content = styled(Box)(() => ({}))
export const Sections = styled(Box)(() => ({}))

export const Card = styled(Box)(({ theme }) => ({
  padding: "22px 32px",
  background: theme.palette.common.white,
  boxShadow: "12px 14px 23px rgba(0, 0, 0, 0.03)",
  borderRadius: "26px",
}))

export const Description = styled(Typography)(() => ({
  margin: "12px 0",
}))

export const Download = styled(Box)(() => ({
  margin: "24px 0",
  textAlign: "left",
  a: {
    background: "rgba(172, 172, 172, 0.1)",
    color: colors.black,
    textDecoration: "none",
    borderRadius: "21px",
    fontWeight: "400",
    fontSize: "0.875rem",
    height: "36px",
    maxWidth: "175px",
    padding: "10px 20px",
    margin: "0",
    width: "auto",
  },
}))
